module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('v-row', {
    attrs: {
      "justify": "center"
    }
  }, [_c('v-dialog', {
    attrs: {
      "width": "600px"
    },
    on: {
      "input": function($event) {
        return _vm.$emit('input')
      }
    },
    model: {
      value: (_vm.value),
      callback: function($$v) {
        _vm.value = $$v
      },
      expression: "value"
    }
  }, [_c('v-card', [_c('v-card-title', [_c('span', {
    staticClass: "headline"
  }, [_vm._v("Create payment/receipt record")])]), _vm._v(" "), _c('v-card-text', [_c('v-row', [_c('v-col', [_c('v-combobox', {
    attrs: {
      "items": _vm.clients,
      "search-input": _vm.searchClient,
      "hide-details": "auto",
      "item-text": "name",
      "label": "Supplier/Customer",
      "dense": "",
      "small-chips": "",
      "outlined": ""
    },
    on: {
      "update:searchInput": function($event) {
        _vm.searchClient = $event
      },
      "update:search-input": function($event) {
        _vm.searchClient = $event
      }
    },
    scopedSlots: _vm._u([{
      key: "no-data",
      fn: function() {
        return [_c('v-list-item', [_c('v-list-item-content', [_c('v-list-item-title', [_vm._v("\n                      No results matching \"\n                      "), _c('strong', [_vm._v(_vm._s(_vm.searchClient))]), _vm._v("\". Press\n                      "), _c('kbd', [_vm._v("enter")]), _vm._v(" to create a new one\n                    ")])], 1)], 1)]
      },
      proxy: true
    }]),
    model: {
      value: (_vm.payment.customer),
      callback: function($$v) {
        _vm.$set(_vm.payment, "customer", $$v)
      },
      expression: "payment.customer"
    }
  })], 1)], 1), _vm._v(" "), _c('v-row', [_c('v-col', [_c('v-combobox', {
    attrs: {
      "items": _vm.filteredCampaigns,
      "search-input": _vm.searchCampaign,
      "hide-details": "auto",
      "label": "Campaign Name",
      "item-text": "name",
      "dense": "",
      "small-chips": "",
      "outlined": ""
    },
    on: {
      "update:searchInput": function($event) {
        _vm.searchCampaign = $event
      },
      "update:search-input": function($event) {
        _vm.searchCampaign = $event
      }
    },
    scopedSlots: _vm._u([{
      key: "no-data",
      fn: function() {
        return [_c('v-list-item', [_c('v-list-item-content', [_c('v-list-item-title', [_vm._v("\n                      No results matching \"\n                      "), _c('strong', [_vm._v(_vm._s(_vm.searchCampaign))]), _vm._v("\". Press\n                      "), _c('kbd', [_vm._v("enter")]), _vm._v(" to create a new one\n                    ")])], 1)], 1)]
      },
      proxy: true
    }]),
    model: {
      value: (_vm.payment.campaign),
      callback: function($$v) {
        _vm.$set(_vm.payment, "campaign", $$v)
      },
      expression: "payment.campaign"
    }
  })], 1)], 1), _vm._v(" "), _c('v-row', [_c('v-col', {
    attrs: {
      "cols": "12",
      "md": "6",
      "sm": "12"
    }
  }, [_c('v-text-field', {
    attrs: {
      "label": "Reference No.",
      "placeholder": "2019001467",
      "hide-details": "auto",
      "outlined": "",
      "dense": ""
    },
    model: {
      value: (_vm.payment.referenceNo),
      callback: function($$v) {
        _vm.$set(_vm.payment, "referenceNo", $$v)
      },
      expression: "payment.referenceNo"
    }
  })], 1), _vm._v(" "), _c('v-col', {
    attrs: {
      "cols": "12",
      "md": "6",
      "sm": "12"
    }
  }, [_c('v-text-field', {
    attrs: {
      "label": "I/O Quote No.",
      "placeholder": "IO-2019001521",
      "hide-details": "auto",
      "outlined": "",
      "dense": ""
    },
    model: {
      value: (_vm.payment.IOQuoteNo),
      callback: function($$v) {
        _vm.$set(_vm.payment, "IOQuoteNo", $$v)
      },
      expression: "payment.IOQuoteNo"
    }
  })], 1)], 1), _vm._v(" "), _c('v-row', [_c('v-col', {
    attrs: {
      "cols": "12",
      "md": "6",
      "sm": "12"
    }
  }, [_c('v-text-field', {
    attrs: {
      "label": "Voucher No.",
      "placeholder": "RV2006002",
      "hide-details": "auto",
      "outlined": "",
      "dense": ""
    },
    model: {
      value: (_vm.payment.voucherNo),
      callback: function($$v) {
        _vm.$set(_vm.payment, "voucherNo", $$v)
      },
      expression: "payment.voucherNo"
    }
  })], 1), _vm._v(" "), _c('v-col', {
    attrs: {
      "cols": "12",
      "md": "6",
      "sm": "12"
    }
  }, [_c('v-text-field', {
    attrs: {
      "label": "Invoice No.",
      "placeholder": "2019001521",
      "hide-details": "auto",
      "outlined": "",
      "dense": ""
    },
    model: {
      value: (_vm.payment.invoiceNo),
      callback: function($$v) {
        _vm.$set(_vm.payment, "invoiceNo", $$v)
      },
      expression: "payment.invoiceNo"
    }
  })], 1)], 1), _vm._v(" "), _c('v-row', [_c('v-col', {
    attrs: {
      "cols": "12",
      "md": "12",
      "sm": "12"
    }
  }, [_c('v-textarea', {
    attrs: {
      "outlined": "",
      "name": "description",
      "dense": "",
      "hide-details": "auto",
      "label": "Description",
      "placeholder": "IO-2019001465 I Invoice 2019001467"
    },
    model: {
      value: (_vm.payment.description),
      callback: function($$v) {
        _vm.$set(_vm.payment, "description", $$v)
      },
      expression: "payment.description"
    }
  })], 1)], 1), _vm._v(" "), _c('v-row', [_c('v-col', {
    attrs: {
      "cols": "12",
      "md": "6",
      "sm": "12"
    }
  }, [_c('v-text-field', {
    attrs: {
      "label": "Debit",
      "placeholder": "3,000",
      "prefix": "$",
      "hide-details": "auto",
      "outlined": "",
      "dense": ""
    },
    model: {
      value: (_vm.payment.debit),
      callback: function($$v) {
        _vm.$set(_vm.payment, "debit", $$v)
      },
      expression: "payment.debit"
    }
  })], 1), _vm._v(" "), _c('v-col', {
    attrs: {
      "cols": "12",
      "md": "6",
      "sm": "12"
    }
  }, [_c('v-text-field', {
    attrs: {
      "label": "Credit",
      "prefix": "$",
      "hide-details": "auto",
      "placeholder": "500",
      "outlined": "",
      "dense": ""
    },
    model: {
      value: (_vm.payment.credit),
      callback: function($$v) {
        _vm.$set(_vm.payment, "credit", $$v)
      },
      expression: "payment.credit"
    }
  })], 1)], 1), _vm._v(" "), _c('v-row', [_c('v-col', {
    attrs: {
      "cols": "12",
      "md": "12",
      "sm": "12"
    }
  }, [_c('v-textarea', {
    attrs: {
      "outlined": "",
      "name": "remark",
      "dense": "",
      "hide-details": "auto",
      "label": "Remarks",
      "placeholder": "Remarks"
    },
    model: {
      value: (_vm.payment.remarks),
      callback: function($$v) {
        _vm.$set(_vm.payment, "remarks", $$v)
      },
      expression: "payment.remarks"
    }
  })], 1)], 1), _vm._v(" "), _c('v-row', [_c('v-col', {
    attrs: {
      "cols": "6",
      "md": "6"
    }
  }, [_c('v-combobox', {
    attrs: {
      "items": _vm.sales,
      "search-input": _vm.searchSale,
      "hide-details": "auto",
      "item-text": "name",
      "label": "Sale Person",
      "dense": "",
      "multiple": "",
      "small-chips": "",
      "outlined": ""
    },
    on: {
      "update:searchInput": function($event) {
        _vm.searchSale = $event
      },
      "update:search-input": function($event) {
        _vm.searchSale = $event
      }
    },
    scopedSlots: _vm._u([{
      key: "no-data",
      fn: function() {
        return [_c('v-list-item', [_c('v-list-item-content', [_c('v-list-item-title', [_vm._v("\n                      No results matching \"\n                      "), _c('strong', [_vm._v(_vm._s(_vm.searchSale))]), _vm._v("\". Press\n                      "), _c('kbd', [_vm._v("enter")]), _vm._v(" to create a new one\n                    ")])], 1)], 1)]
      },
      proxy: true
    }]),
    model: {
      value: (_vm.payment.salePerson),
      callback: function($$v) {
        _vm.$set(_vm.payment, "salePerson", $$v)
      },
      expression: "payment.salePerson"
    }
  })], 1), _vm._v(" "), _c('v-col', {
    attrs: {
      "cols": "6",
      "md": "6"
    }
  }, [_c('v-menu', {
    ref: "pickDate",
    attrs: {
      "close-on-content-click": false,
      "return-value": _vm.payment.date,
      "transition": "scale-transition",
      "offset-y": "",
      "min-width": "290px"
    },
    on: {
      "update:returnValue": function($event) {
        return _vm.$set(_vm.payment, "date", $event)
      },
      "update:return-value": function($event) {
        return _vm.$set(_vm.payment, "date", $event)
      }
    },
    scopedSlots: _vm._u([{
      key: "activator",
      fn: function(ref) {
        var on = ref.on;

        return [_c('v-text-field', _vm._g({
          attrs: {
            "label": "Date",
            "prepend-inner-icon": "event",
            "outlined": "",
            "dense": "",
            "readonly": ""
          },
          model: {
            value: (_vm.payment.date),
            callback: function($$v) {
              _vm.$set(_vm.payment, "date", $$v)
            },
            expression: "payment.date"
          }
        }, on))]
      }
    }]),
    model: {
      value: (_vm.pickDate),
      callback: function($$v) {
        _vm.pickDate = $$v
      },
      expression: "pickDate"
    }
  }, [_vm._v(" "), _c('v-date-picker', {
    attrs: {
      "no-title": "",
      "scrollable": ""
    },
    model: {
      value: (_vm.payment.date),
      callback: function($$v) {
        _vm.$set(_vm.payment, "date", $$v)
      },
      expression: "payment.date"
    }
  }, [_c('v-spacer'), _vm._v(" "), _c('v-btn', {
    attrs: {
      "text": "",
      "color": "secondary"
    },
    on: {
      "click": function($event) {
        _vm.pickDate = false
      }
    }
  }, [_vm._v("Cancel")]), _vm._v(" "), _c('v-btn', {
    attrs: {
      "text": "",
      "color": "secondary"
    },
    on: {
      "click": function($event) {
        return _vm.$refs.pickDate.save(_vm.payment.date)
      }
    }
  }, [_vm._v("OK")])], 1)], 1)], 1)], 1)], 1), _vm._v(" "), _c('v-card-actions', [_c('v-spacer'), _vm._v(" "), _c('v-btn', {
    attrs: {
      "color": "red darken-1",
      "text": ""
    },
    on: {
      "click": _vm.close
    }
  }, [_vm._v("Cancel")]), _vm._v(" "), _c('v-btn', {
    attrs: {
      "color": "green darken-1",
      "disabled": _vm.$v.payment.$invalid,
      "text": ""
    },
    on: {
      "click": _vm.doAction
    }
  }, [_vm._v("Submit")])], 1)], 1)], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-6c99efec"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/views/Finance/CreatePaymentRecordModal.vue
// module id = 2179
// module chunks = 0